import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Card, Container, Tab, Tabs } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import { ProgramBlockItem } from './ProgramBlockItem';
import { ProgramTitle } from './ProgramTitle';
import { AcceptPositionButton } from './AcceptPositionButton';
import { getStartDateFromProgram, isNowBeforeDate } from '../../../util';
import { urlConst } from '../../../consts';

const BLOCK_HEADER_HEIGHT = 45;
const HEADER_HEIGHT = 156;
const HEADER_MD_HEIGHT = 246;
const APPROVE_BUTTON_HEIGHT = 46;
const APPROVE_BUTTON_MD_HEIGHT = 54;

function OldProgramsList(props) {
    const { events } = props;
    return (
        (events && events.length > 0 && (
            <Card className="mx-auto mt-5">
                <Card.Body>
                    <h5 className="text-muted">Архив событий:</h5>
                    <ul>
                        {events.map((event) => (
                            <li key={event.id}>
                                <Link className="text-muted" to={`/event/${event.name}/${urlConst.PROGRAM}`}>
                                    {event.title}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </Card.Body>
            </Card>
        )) ||
        null
    );
}

function ProgramPage() {
    const [curDay, setCurDay] = useState(localStorage.getItem('program-current-day'));
    const [activeBlock, setActiveBlock] = useState(null);
    const { eventName } = useParams();
    const { approved, program, events } = useSelector((state) => ({
        approved: state.clientVoices.approved,
        program: state.program.program,
        events: state.events.events,
    }));
    const handleSelectDay = useCallback((dayId) => {
        setCurDay(dayId);
        localStorage.setItem('program-current-day', dayId);
    }, []);
    const showAcceptPositionButton = useMemo(() => {
        if (approved) return false;
        return !isNowBeforeDate(getStartDateFromProgram(program));
    }, [approved, program]);
    const blocksContainerHeight = useMemo(() => {
        const windowHeight = window.innerHeight;
        let headerHeight = window.innerWidth >= 768 ? HEADER_MD_HEIGHT : HEADER_HEIGHT;
        if (showAcceptPositionButton) {
            headerHeight += window.innerWidth >= 768 ? APPROVE_BUTTON_MD_HEIGHT : APPROVE_BUTTON_HEIGHT;
        }
        return windowHeight - headerHeight;
    }, [showAcceptPositionButton]);
    const handleSelectBlock = useCallback(
        (blockId) => {
            setActiveBlock(activeBlock === blockId ? null : blockId);
        },
        [activeBlock]
    );

    useEffect(() => {
        if (
            program &&
            program.items &&
            program.items.length &&
            (!curDay || !program.items.some((item) => item.id === curDay))
        )
            setCurDay(program.items[0].id);
    }, [program, curDay]);

    console.log('render program', program.items && program.items.length, program);
    return (
        <Container className="py-md-5 py-1">
            <ProgramTitle />
            {showAcceptPositionButton && (
                <div className="text-center mb-md-3 mb-1">
                    <AcceptPositionButton />
                </div>
            )}
            {program.items && program.items.length ? (
                <Tabs activeKey={curDay} id="program-days-block" onSelect={handleSelectDay}>
                    {program.items.map((dayItem) => (
                        <Tab eventKey={dayItem.id} key={dayItem.id} title={dayItem.title.toUpperCase()}>
                            {dayItem.items &&
                                dayItem.items.map((blockItem) => (
                                    <ProgramBlockItem
                                        item={blockItem}
                                        key={blockItem.id}
                                        isActive={activeBlock === blockItem.id}
                                        onToggle={handleSelectBlock}
                                        contentHeight={
                                            blocksContainerHeight - BLOCK_HEADER_HEIGHT * dayItem.items.length
                                        }
                                    />
                                ))}
                        </Tab>
                    ))}
                </Tabs>
            ) : (
                <h3 className="text-center mt-3">
                    будет выложена в этом разделе ближе к дню фестиваля (как будет готова)
                </h3>
            )}
            {program && !eventName && <OldProgramsList events={events} />}
        </Container>
    );
}

export default ProgramPage;
